import React from 'react';
import styled from '@emotion/styled';
import { H3, Link, P1 } from '../../primitives';
import { mixins, colors, spaces } from '../../core/styles/theme/default';
import { rem } from 'polished';

const StyledSocialMedia = styled.article`
  display: flex;
  flex-direction: column;

  ${mixins.MQ('medium')} {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(5, minmax(0, auto));
    column-gap: ${rem(spaces.epsilon)};
  }
`;

const StyledTitle = styled(H3)`
  margin-bottom: ${rem(8)};

  ${mixins.MQ('medium')} {
    grid-column: 1 / 6;
    grid-row-start: 2;
  }

  ${mixins.MQ('large')} {
    margin-bottom: ${rem(16)};
    font-size: ${rem(32)};
    line-height: 1.25;
  }
`;

const StyledLead = styled(P1)`
  margin-bottom: ${rem(24)};

  ${mixins.MQ('medium')} {
    margin-bottom: ${rem(32)};
    grid-column: 1 / 6;
    grid-row-start: 3;
  }
`;

const StyledLink = styled(Link)`
  order: 1;

  .m-richtext & {
    text-decoration: none;
  }

  ${mixins.MQ('medium')} {
    order: 0;
    grid-column: 1 / 6;
    grid-row-start: 4;
  }
`;

const StyledSocial = styled.div`
  display: flex;
  border: ${rem(1)} solid ${colors.grue300};
  border-radius: ${rem(2)} ${rem(4)} ${rem(4)} ${rem(2)};
  margin-bottom: ${rem(24)};
  overflow: hidden;

  ${mixins.MQ('medium')} {
    margin-bottom: 0;
    grid-row: 1 / -1;
    grid-column: 6 / -1;
  }

  iframe {
    width: 100%;
    height: ${rem(400)};
  }
`;

const TeaserSocialMedia = (props: TeaserSocialMediaProps) => {
  const { title, socialMediaChannelDescription, embeddedCode, link } = props;

  return (
    <StyledSocialMedia>
      <StyledTitle>{title}</StyledTitle>
      <StyledLead>{socialMediaChannelDescription}</StyledLead>
      <StyledLink
        variant="external"
        linkText={link.linkText}
        link={{
          href: link.url,
          title: link.linkText,
          target: '_blank',
        }}
      />
      <StyledSocial dangerouslySetInnerHTML={{ __html: embeddedCode }} />
    </StyledSocialMedia>
  );
};

export type TeaserSocialMediaProps = {
  title: string;
  socialMediaChannelDescription: string;
  embeddedCode: string;
  link: {
    linkText: string;
    url: string;
  };
};

export default TeaserSocialMedia;
